/**
 * The Dynamics "Selections" lists.
 *
 * All five render the identical Name / Status / Edit table — they differ only in
 * which endpoint, redux slice and modal they use. Adding another list means one
 * entry here, nothing else.
 */

export type LookupSource = "carMovement" | "selection";

export interface LookupConfig {
  /** `type` query param sent to the API and stored on the record. */
  type: string;
  label: string;
  /** Plural form, used in the empty-state message. */
  plural: string;
  source: LookupSource;
}

export const LOOKUPS: LookupConfig[] = [
  {
    type: "movementType",
    label: "Movement Type",
    plural: "Movement Types",
    source: "carMovement",
  },
  {
    type: "platformType",
    label: "Platform Type",
    plural: "Platform Types",
    source: "carMovement",
  },
  {
    type: "vehicleSubStatus",
    label: "Vehicle Sub Status",
    plural: "Vehicle Sub Statuses",
    source: "selection",
  },
  {
    type: "driverSubStatus",
    label: "Driver Sub Status",
    plural: "Driver Sub Statuses",
    source: "selection",
  },
  {
    type: "trafficViolationType",
    label: "Traffic Violation Type",
    plural: "Traffic Violation Types",
    source: "selection",
  },
];

export const lookupSlug = (label: string) =>
  label.toLowerCase().replace(/\s+/g, "-");

/** Index of a list by its slug, or -1. Also resolves the pre-consolidation
 *  tab slugs (`?tab=driver-sub-status`) so old links keep working. */
export const lookupIndexBySlug = (slug?: string | null) =>
  slug ? LOOKUPS.findIndex((l) => lookupSlug(l.label) === slug) : -1;
